import {
  Alert,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  AlertIcon,
  Button,
  Divider,
  ModalHeader,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type UnlinkAllModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
};

export default function UnlinkAllModal({
  isOpen,
  onClose,
  onSubmit,
}: UnlinkAllModalProps): React.ReactElement {
  const [isSubmitting, setSubmitting] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation('table');
  const onSubmitInternal = async () => {
    setSubmitting(true);
    await onSubmit();
    setSubmitting(false);
    onClose();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      size="lg"
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <ModalHeader>{t('clear-links-confirmation.title')}</ModalHeader>
        <Divider orientation="horizontal" />
        <AlertDialogBody marginX={2}>
          {t('clear-links-confirmation.description')}
          <Alert mt={2} status="warning">
            <AlertIcon />
            {t('clear-links-confirmation.warning')}
          </Alert>
        </AlertDialogBody>
        <Divider orientation="horizontal" />
        <AlertDialogFooter gap={2}>
          <Button
            onClick={onSubmitInternal}
            isLoading={isSubmitting}
            variant="outline"
            colorScheme="red"
          >
            {t('clear-links-confirmation.confirm')}
          </Button>
          <Button colorScheme="gray" onClick={onClose}>
            {t('clear-links-confirmation.cancel')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
